import IntegrationSettingPanel from './integrationSettingPanel.container';

export default IntegrationSettingPanel;